module.exports = __webpack_public_path__ + "static/5_section_mockup-0e50a48240557c81eec056cf2d2549a3.png";